<template>
    <div :class="['alert',type==='success' ? 'alert-success' : type==='danger' ? 'alert-danger' : type==='warning' ? 'alert-warning' : 'alert-info']">
        <strong v-if="type==='success'">Success! </strong>
        <strong v-else-if="type==='danger'">Error! </strong>
        <strong v-else-if="type==='warning'">Warning! </strong>
        <strong v-else-if="type==='info'">Note: </strong>
        <slot default></slot>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                required: true
            }
        }
    }
</script>


